import { useState, useEffect } from 'react';
import { Typography } from '@mui/material';

/**
 * CountdownTimer — live countdown naar event.ems.
 * Toont MM:SS als minder dan 1 uur, HH:MM als meer.
 * Update elke seconde via setInterval.
 *
 * @param {object} props
 * @param {number} props.ems - target epoch ms
 * @param {boolean} props.ringing - kleurt rood als true
 */
export default function CountdownTimer({ ems, ringing }) {
    const [display, setDisplay] = useState(_format(ems - Date.now()));

    useEffect(() => {
        // Update meteen op mount zodat er geen flash is
        setDisplay(_format(ems - Date.now()));

        const id = setInterval(() => {
            const ms = ems - Date.now();
            setDisplay(_format(ms));
            // Stop timer als overdue
            if (ms <= 0) clearInterval(id);
        }, 1000);

        return () => clearInterval(id);
    }, [ems]);

    return (
        <Typography sx={{
            fontSize: 11,
            fontWeight: 500,
            fontFamily: 'monospace',
            color: ringing ? 'var(--j-danger)' : '#85B7EB',
            letterSpacing: '0.05em',
        }}>
            {display}
        </Typography>
    );
}

// ─── helpers ──────────────────────────────────────────

/**
 * Formatteert milliseconden naar leesbare countdown string.
 * < 1 uur  → MM:SS
 * >= 1 uur → HH:MM:SS
 * overdue  → 00:00
 * @param {number} ms
 * @returns {string}
 */
const _format = (ms) => {
    if (ms <= 0) return '00:00';
    const totalSec = Math.floor(ms / 1000);
    const h  = Math.floor(totalSec / 3600);
    const m  = Math.floor((totalSec % 3600) / 60);
    const s  = totalSec % 60;
    if (h > 0) {
        return `${_pad(h)}:${_pad(m)}:${_pad(s)}`;
    }
    return `${_pad(m)}:${_pad(s)}`;
};

const _pad = (n) => String(n).padStart(2, '0');
